import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { toast } from 'react-toastify';


export default function IC_supplier({ data, entity, setDataKeyValue }) {

    const [showModalSupplier, setShowModalSupplier] = useState(false);

    async function searchIvaSupplier(iva) {
        var constraints = [
            { fieldName: "vatNumber", type: "value", value: iva }
        ]
        var sorting = { 'field': 'id', 'order': 'desc' }
        var response = await DataManager.searchItems('supplier', 1, 100, sorting, '', [], constraints);
        if (response.success === 1 && response.body.length > 0) {
            setShowModalSupplier(true);
        }
    }

    function copyAddressSupplier() {
        if (data && data.offices.length === 0) {
            var temp = []
            var body = {
                address: data.address,
                cap: data.cap,
                city: data.city,
                email: "",
                idCountry: data.idCountry,
                internalNotes: "",
                isDeliveryDefault: true,
                name: "Sede 1",
                phone: "39"
            }
            temp.push(body);
            if (data.offices !== temp) {
                setDataKeyValue('offices', temp)
            }
        }
    }

    useEffect(() => {
        if (data.vatNumber !== "" && window.location.pathname === "/entity/supplier/add") {
            searchIvaSupplier(data.vatNumber);
        }
    }, [data.vatNumber])

    return (
        <>
            <Button size='sm' className='mb-3' variant='primary' onClick={() => { copyAddressSupplier() }}>Copia indirizzo</Button>
            {showModalSupplier ? <>
                <Modal show={showModalSupplier} onHide={() => setShowModalSupplier(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Partita IVA già esistente</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>È già presente in anagrafica un fornitore con la stessa Partita IVA. In fase di caricamento ordine dovrai prestare attenzione a selezionare quello corretto.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={() => { setShowModalSupplier(false) }}>Ho capito</Button>
                    </Modal.Footer>
                </Modal>
            </> : null}
        </>
    )
};
